import React, {useState} from "react";
import {  Route, Routes, Navigate } from "react-router-dom";
import FixedPlugin from "../views/RightSideBar/rightSideBar.js";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import CustomerSidebar from "components/Sidebar/CustomerSidebar.js";
import CustomerHeader from "components/Headers/CustomerHeader.js";

import routes from "routes.js";

import {
  Button,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Modal, ModalHeader,  ModalBody, ModalFooter,
} from "reactstrap";

const Admin = (props) => {
  const url = window.location.href;
  const pathParts = new URL(url).pathname.split('/');
  const cid = pathParts[3]; 
  const lid = pathParts[4]; 

  const [actionModal, setActionModal] = useState(false);

  
  const closeActionModal = () => {
    setActionModal(false);
  };


  const [leadStatusModal, setLeadStatusModal] = useState(false);

 
  const closeLeadStatusModal = () => {
    setLeadStatusModal(false);
  };
  
  const mainContent = React.useRef(null);
 
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/customer") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };


  return (
    <>

      <Modal id="actionModal" isOpen={actionModal} toggle={closeActionModal} size="lg" >
        <ModalHeader closeButton>
            Action
        </ModalHeader>
        <ModalBody>
              <Row>
                  <Col lg="6">
                        <FormGroup>
                          <Input
                            className="form-control-alternative"
                            id="input-sms-remark"
                            placeholder=""
                            type="checkbox"
                          />
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Sms
                          </label>
                        </FormGroup>

                        <FormGroup>
                          <Input
                            className="form-control-alternative"
                            id="input-sms-remark"
                            placeholder=""
                            type="checkbox"
                          />
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email
                          </label>
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Send
                      </Button>
                      </Col>
                    </Row>
                
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeActionModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal id="leadStatusModal" isOpen={leadStatusModal} toggle={closeLeadStatusModal} size="lg" >
        <ModalHeader closeButton>
            Lead Status Update
        </ModalHeader>
        <ModalBody>
              <Row>
                  <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Remark
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-leadstatus-remark"
                            placeholder=""
                            type="textarea"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Save
                      </Button>
                      </Col>
                    </Row>
                
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeLeadStatusModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <CustomerSidebar
        {...props}
        cid={cid}
        lid={lid}
        routes={routes}
        logo={{
          innerLink: "/admin/lead-list",
          imgSrc: require("../assets/img/brand/logo.png"),
          imgAlt: "...",
        }}
      />


      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />

        <CustomerHeader cid={cid} lid={lid}  />
        
        <Container className="mt--7" fluid>
        
      
          <Col className="order-xl-1" xl="12" style={{ paddingLeft: "0" }}>
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/customer/detail" replace />} />
          </Routes>
          </Col>
        {/* </Row> */}

        <FixedPlugin />

      </Container>

        <Container fluid>
          <AdminFooter />
        </Container>
      </div>  
      
    </>
  );
};

export default Admin;